import Vue from 'vue';
import VueI18n from 'vue-i18n'
import en from "./modules/en";
import zh from "./modules/zh";

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'zh',
  messages: {
    en,
    zh
  },
})